export const DIV_CODE_COPRO = "COPRO";
export const DIV_CODE_GF = "GF";
export const DIV_CODE_SAF = "SAF";

export default {DIV_CODE_COPRO};
